import {
  CariSep,
  DataBpjs,
  DataDokter,
  DataJaminan,
  DataKeluarRs,
  DataKlaim,
  DataKunjungan,
  DataMultiRecordPCare,
  DataNik,
  DataPelayanan,
  DataSarana,
  DataSep,
} from "./../WrapperLazyExport";

import {
  WS_RKN_DKT,
  WS_MTR_KLM,
  WS_RKN_SEP,
  WS_MTR_KNJ,
  WS_MTR_PLN,
  WS_MTR_JMN,
  WS_PST_BPJS,
  WS_PST_NIK,
  WS_SEP_SEP,
  WS_RJK_RMR,
  WS_RJK_SRN,
  WS_RJK_KRS,
} from "App/constants";

export const menuWsBPJS = {
  [WS_RKN_DKT]: <DataDokter />,
  [WS_RKN_SEP]: <CariSep />,
  [WS_MTR_KLM]: <DataKlaim />,
  [WS_MTR_KNJ]: <DataKunjungan />,
  [WS_MTR_PLN]: <DataPelayanan />,
  [WS_MTR_JMN]: <DataJaminan />,
  [WS_PST_BPJS]: <DataBpjs />,
  [WS_PST_NIK]: <DataNik />,
  [WS_SEP_SEP]: <DataSep />,
  [WS_RJK_RMR]: <DataMultiRecordPCare />,
  [WS_RJK_SRN]: <DataSarana />,
  [WS_RJK_KRS]: <DataKeluarRs />,
};
